
import Vue from 'vue'
import RadioButton from '@/components/RadioButton.vue'
import SectionTitle from '@/pages/product/components/SectionTitle.vue'
import Tooltip from '@/components/Tooltip.vue'

enum DELIVERY_METHODS {
  NORMAL_DELIVERY,
  QUICK_DELIVERY
}

export default Vue.extend({
  components: {
    RadioButton,
    SectionTitle,
    Tooltip
  },
  props: {
    isDeliveryFirstOption: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      deliveryMethods: DELIVERY_METHODS,
      activeDeliveryMethod: DELIVERY_METHODS.NORMAL_DELIVERY,
       bodyTheme: 'sw-Tooltip_Light'
    }
  },
  computed: {
    normalDelivery() {
      return this.$store.state.delivery_options[0]
    },
    quickDelivery() {
      return this.$store.state.delivery_options[1]
    },
    optionTitle() : string {
      return this.isDeliveryFirstOption ? 'first_selected_option' : 'second_selected_option'
    },
    isOrderPlainProduct(): boolean {
      return this.$store.state.isOrderPlainProduct
    },
     isShowQuickDeliveryDetail(): boolean {
      return !this.quickDelivery.selectable || this.isOrderPlainProduct
    }
  },
  methods: {
    onChangeDeliveryMethod(method: number, id: number, optionDisabled?: boolean) {
      if (this.activeDeliveryMethod === method || optionDisabled) return
      this.activeDeliveryMethod = method
      this.$store.commit('setSelectedId', { content: this.optionTitle , id: id })
      this.$emit('refreshProductInfo', {})
    }
  }
})
